export default __webpack_public_path__ + "static/media/aluno.9e26c2a9.png";